
let initialState = {
    api: ''
};

const SGKReducer = (state = initialState, action) => {
    return state;
}

export default SGKReducer;